module.exports = __webpack_public_path__ + "img/yishi10.69c5dee3.jpg";